import { render } from "./ConnectionView.vue?vue&type=template&id=5331e820&scoped=true&ts=true"
import script from "./ConnectionView.vue?vue&type=script&lang=ts"
export * from "./ConnectionView.vue?vue&type=script&lang=ts"

import "./ConnectionView.vue?vue&type=style&index=0&id=5331e820&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5331e820"]])

export default __exports__